import {
    Link,
} from 'react-router-dom'

import Label from 'app/shared-components/Label'
import LabelPanel from 'app/shared-components/LabelPanel'
import {
    NotificationIconProps,
} from '../NotificationIcon/notificationIcon.types'

import {
    SizeLink, TypeLink,
} from './SkyNetLink.enum'
import useStyles from './SkyNetLink.style'
import SkyNetLinkContent from './SkyNetLinkContent'

const defaultCustomClasses = {}

export default function SkyNetLink({
    size = SizeLink.M,
    type = TypeLink.INTERNAL,
    link,
    state,
    text,
    title,
    notificationIconProps,
    className,
    value,
    customClasses = defaultCustomClasses,
}: Readonly<{
    text?: string,
    link?: string,
    size?: SizeLink,
    type?: TypeLink,
    title?: string,
    state?: Record<string, any>,
    notificationIconProps?: NotificationIconProps,
    className?: string,
    value?: string,
    customClasses?: { wrapper?: string },
}>) {
    const {
        classes,
        cx,
    } = useStyles()

    return (
        <div className={className}>
            {title
                && (
                    <LabelPanel notificationIconProps={notificationIconProps}>
                        <Label title={title} />
                    </LabelPanel>
                )}
            {link
                ? (
                    <div className={cx(classes.wrapper, customClasses.wrapper)}>
                        <Link
                            data-testid={`SkyNetLink::${link}`}
                            to={link}
                            state={state}
                            target={type === TypeLink.EXTERNAL ? '_blank' : undefined}
                            rel={type === TypeLink.EXTERNAL ? 'noopener noreferrer' : undefined}
                            className={cx(classes.link, classes[size])}
                        >
                            <SkyNetLinkContent
                                size={size}
                                type={type}
                                text={text}
                                value={value}
                            />
                        </Link>
                    </div>
                ) : '-'}
        </div>
    )
}
